<div class="container-fluid px-0">
  <div class="row  mx-0 my-0 h-100">
    <div class="col-12 px-0 d-flex justify-content-center">
      <form class="form-style">
        <div class="rectangle">
          <div class="col-lg-5 col-md-5 col-sm-5 col-12 px-0 d-flex card-div">
            <div class="col-12 px-0 d-flex flex-column">
              <label class="title">Kart Bilgilerinizi Girin</label>
              <img class="card-image" [src]="imageUrl" alt="logo"/>
            </div>
          </div>
          <div class="col-lg-1 col-md-1 col-sm-1 px-0 d-flex">
            <div class="path"></div>
          </div>
          <div
            [ngClass]="(id !== 'create-virtual-card') ? 'col-12 col-md-6 col-sm-6 col-lg-6 px-0 input-group-style':'col-12 col-md-6 col-lg-6 col-sm-6 px-0 input-group-style-second'">
            <div class="col-12 px-0 d-flex input-div" *ngIf="id !== 'create-virtual-card'">
              <mat-form-field class="input-style">
                <mat-label>Kart numarasını girin</mat-label>
                <input matInput>
              </mat-form-field>
            </div>
            <div class="col-12 px-0 d-flex input-div" *ngIf="id !== 'create-virtual-card'">
              <mat-form-field class="input-style">
                <mat-label>Son kullanma tarihini girin</mat-label>
                <input matInput>
              </mat-form-field>
            </div>
            <div class="col-12 px-0 d-flex input-div" *ngIf="id !== 'create-virtual-card'">
              <mat-form-field class="input-style">
                <mat-label>Kartın arka yüzündeki CVV kodunu girin</mat-label>
                <input matInput>
              </mat-form-field>
            </div>
            <div class="col-12 px-0 d-flex input-div">
              <mat-form-field class="input-style">
                <mat-label>Kart kayıt adını girin</mat-label>
                <input matInput>
              </mat-form-field>
            </div>
            <div class="col-12 px-0 d-flex checkbox-div" *ngIf="id === 'create-virtual-card'">
              <mat-checkbox class="checkbox-style"><label class="checkbox-description">Lütfen <span class="text-style">Çerçeve Ödeme Hizmetleri Sözleşmesini</span>
                ve <span class="text-style">Uygulama Ödeme Hizmetleri Sözleşmesi</span>'ni kabul edin.</label>
              </mat-checkbox>
            </div>
            <div class="col-12 px-0 d-flex input-div">
              <button class="button-style"><span class="text-style">Kaydet</span></button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
